import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';
import ncp_bg from '../../assets/images/ncp/2026/ncp_bg.jpg';

const usePrizeStyles = createUseStyles((theme: Theme) => {
    return {
        prizeContainer: {
            backgroundImage: `url(${ncp_bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
        },
        contentWrapper: {
            maxWidth: '100%',
            width: '100%',
            boxSizing: 'border-box',
        },
        partnerSelectionBox: {
            display: 'flex',
            justifyContent: 'center',
            gap: 0,
            marginBottom: 0,
            backgroundColor: theme.colors.ivory_beige,
            width: '100%',
            padding: 0,
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                flexWrap: 'wrap',
            },
        },
         partnerSelection: {
            flex: 1,
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            backgroundColor: theme.colors.ivory_beige,
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
            '&.active': {
                backgroundImage: `url(${ncp_bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            },
            '& button': {
                padding: theme.spacing(2),
                minWidth: 'auto',
                width: '100%',
                height: '100%',
                margin: 0,
                backgroundColor: 'transparent',
            },
            '& img': {
                maxWidth: '90%',
                maxHeight: '80%',
                objectFit: 'contain',
            },
            [theme.breakpoints.down('sm')]: {
                height: '70px',
                flex: '0 0 33.333%',
                '& button': {
                    padding: theme.spacing(1),
                },
            },
        },
        prizeBannerBox: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: theme.spacing(20),
            marginBottom: theme.spacing(12),
            marginTop: theme.spacing(12),
            padding: `0 ${theme.spacing(6)}`,
            width: '100%',
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row',
                gap: theme.spacing(2),
                marginBottom: theme.spacing(10),
                marginTop: theme.spacing(10),
                padding: `0 ${theme.spacing(2)}`,
            },
        },
        prizeImage: {
            width: '425px',
            height: 'auto',
            objectFit: 'contain',
            [theme.breakpoints.down('sm')]: {
                width: '200px',
            },
        },
        titleBox: {
            textAlign: 'center',
            marginBottom: theme.spacing(8),
            padding: `0 ${theme.spacing(6)}`,
            width: '100%',
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                padding: `0 ${theme.spacing(2)}`,
            },
        },
        title: {
            fontFamily: theme.fonts.apex,
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#FFFFFF',
            marginBottom: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                fontSize: '22px',
            },
        },
        subtitle: {
            fontFamily: theme.fonts.apex,
            fontSize: '20px',
            color: '#FFFFFF',
            marginTop: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px',
            },
        },
        stepsContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(6),
            width: '100%',
            maxWidth: '900px',
            margin: '0 auto',
            padding: `0 ${theme.spacing(3)}`,
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                padding: `0 ${theme.spacing(2)}`,
                gap: theme.spacing(3),
            },
        },
        prizeStep: {
            margin: 0,
            display: 'flex',
            borderWidth: '5px',
            borderStyle: 'dotted',
            borderColor: theme.colors.ivory_beige,
            padding: `${theme.spacing(3)} ${theme.spacing(8)}`,
            position: "relative",
            backgroundColor: 'transparent',
            borderRadius: '16px',
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
                borderWidth: '3px',
            }
        },
        prizeStepText: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.ivory_beige,
            fontSize: '18px',
            fontWeight: 'bold',
            zIndex: 10,
            textAlign: 'center',
            lineHeight: 1.6,
            [theme.breakpoints.down('sm')]: {
                padding: '5px',
                fontSize: '14px',
            }
        },
        digitImg: {
            height: '100%',
            maxHeight: '90px',
            filter: 'drop-shadow(0px 0px 0px black)',
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translate(-50%,-50%)',
            [theme.breakpoints.down('sm')]: {
                maxHeight: '60px',
            }
        },
        digitImg2: {
            height: '100%',
            maxHeight: '90px',
            filter: 'drop-shadow(0px 0px 0px black)',
            position: 'absolute',
            top: '50%',
            left: '100%',
            transform: 'translate(-50%,-50%)',
            [theme.breakpoints.down('sm')]: {
                maxHeight: '60px',
            }
        },
    };
});

export default usePrizeStyles;